<template>
  <div class="container-fluid mt-3">
    <TopSection :title="$t('myProfile') | capitalize ">
      <template v-slot:actions>
        <span
          class="btn px-3 mr-3 btn-outline-primary"
          @click="$router.go(-2)"
        >
          {{ $t("cancel") | capitalize }}
        </span>
        <span
          class="btn px-4 btn-primary"
          @click="saveUser"
          v-if="isSuperUser"
        >
          {{ $t('save') | capitalize }}
        </span>
      </template>
    </TopSection>

    <div class="row pt-4">
      <div class="col-2">
        <div class="column text-center">
          <Avatar
            :username="username"
            :size="132"
          />
        </div>
      </div>

      <div class="col-4">
        <div class="column">
          <div>
            <label class="label-text pt-2">{{ $t("name_and_last_name") | capitalize }}</label>
            <input
              v-model="name_and_last_name"
              class="form-control"
            >
          </div>

          <div>
            <label class="label-text pt-2">{{ $t("email") | capitalize }}</label>
            <input
              v-model="email"
              class="form-control"
              disabled
            >
          </div>
          <div>
            <label class="label-text pt-2">{{ $t("organization") | capitalize }}</label>
            <input
              v-model="member.username"
              class="form-control"
              disabled
            >
          </div>
          <div>
            <label class="label-text pt-2">{{ $t("language") | capitalize }}</label>
            <LanguageSelector />
          </div>
        </div>
      </div>

      <div class="col-4">
        <div>
          <div v-if="member && member.org_type===orgTypes.MLC">
            <label class="label-text pt-2">{{ $t("type") | upper }}</label>

            <Multiselect
              v-model="user_type"
              :placeholder="$t('select_type')"
              :allow-empty="false"
              :options="users_types"
              disabled
            />
          </div>
        </div>
      </div>
    </div>
    <MandatesSelector :mandates="mandates" v-if="org_type !== orgTypes.MLC || isSisterSociety" />
  </div>
</template>


<script>
import { mapGetters, mapState } from "vuex"
import { ApiCalls } from "@/assets/libs/services"
import LanguageSelector from "@/components/Modules/LanguageSelector"

const manadateScopes = {
  WORLDWIDE: "ww",
  DOMESTIC: "domestic"
}

export default {
  name: "User",
  components: {
    LanguageSelector
  },
  data () {
    return {
      loading_status: false,
      mandates: [],
      status: "",
      org_type: "",
      username: "",
      email: "",
      user_type: "",
      name_and_last_name: "",
      member: "",
      saving: false
    }
  },
  computed: {
    ...mapState("soundsys", [
      "users_types",
      "countries",
    ]),
    ...mapState("members", ["language"]),
    ...mapGetters("soundsys", ["user_id", "isSuperUser", "orgTypes", "isSisterSociety"]),
  },
  methods: {
    refreshUser () {
      ApiCalls.refreshUser()
    },
    resetPassword () {
      ApiCalls.resetPassword()
        .then(() => { this.$toasted.global.toast(this.$t("email_sent")) })
        .catch(err => { this.$toasted.global.toast(err.error) })
    },
    actionClass (expected) {
      let out = ""

      if (this.status !== expected) {
        out += "clear"
      }

      return out
    },
    toast_error (msg) {
      this.$toasted.global.toast(msg)
    },
    saveUser () {
      this.saving = true

      let data = {
        name_and_last_name: this.name_and_last_name,
        mode: "user_info",
        id: this.user_id,
        language: this.language.alpha_3,
      }

      ApiCalls.save_user(data)
        .then(() => {
          this.saving = false
          this.$router.go(-2)
          this.$toasted.global.toast(this.$t("user_saved"))
        })
        .catch(error => {
          this.saving = false
          this.$toasted.global.toast(error.error)
        })
    },
    copyMandates (mandates) {
      if (!mandates) return []
      return mandates.map(mandate => ({
        name: mandate.name,
        domestic: mandate.scope === manadateScopes.DOMESTIC,
        worldwide: mandate.scope === manadateScopes.WORLDWIDE,
        countries: mandate.countries,
        has_agreement: mandate.has_agreement
      }))
    },
    mapData (data) {
      /* initial data when edit an user */
      this.username = data.username
      this.mandates = this.copyMandates(data.mandates)
      this.org_type = data.member.org_type
      this.email = data.profile.email
      this.user_type = data.profile.user_type
      this.status = data.profile.status.toUpperCase()
      this.name_and_last_name = data.profile.name_and_last_name
      this.member = data.member
    },
  },
  mounted () {
    ApiCalls.getUser(this.user_id).then(resp => {
      this.mapData(resp)
      ApiCalls.getUserLang()
    })
  }
}
</script>

